module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.orderExist) ? _c('div', {
    staticClass: "order-actions"
  }, [_c('button', {
    staticClass: "action-btn",
    style: (("background-color:" + (_vm.globalColors.primary) + ";border-color:" + (_vm.globalColors.primary))),
    on: {
      "click": function($event) {
        _vm.$emit('see-detail')
      }
    }
  }, [_vm._v("Ver Pedido")]), _vm._v(" "), (_vm.unpaid) ? _c('button', {
    staticClass: "action-btn",
    style: (("background-color:" + (_vm.globalColors.primary) + ";border-color:" + (_vm.globalColors.primary))),
    on: {
      "click": function($event) {
        _vm.$emit('cancel-order')
      }
    }
  }, [_vm._v("\n\t\tCancelar Pedido\n\t")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ba2082e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/order-actions.vue
// module id = 1071
// module chunks = 2